<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<form [formGroup]="formProgramacaoFerias" #ProgramacaoFerias="ngForm">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="card-title mb-0">Programação de Férias</h3>
      <button
        *ngIf="
          formProgramacaoFerias.get('matricula').value !== '' &&
          formProgramacaoFerias.get('nomeFuncionario').value !== ''
        "
        type="button"
        class="btn btn-primary"
        (click)="downloadPDF()"
      >
        <i class="fa fa-file-pdf"></i>
        PDF
      </button>
    </div>

    <div class="card-body">
      <div class="row align-items-end">
        <div class="col-md-3 form-group">
          <label class="font-weight-semibold">Matrícula</label>
          <div class="input-group">
            <input
              #inputMatricula
              class="form-control"
              type="text"
              mask="0*"
              maxlength="9"
              (keyup)="alterarMatricula()"
              (keyup.enter)="buscarColaborador(this.formProgramacaoFerias.get('matricula').value)"
              formControlName="matricula"
              placeholder="Matrícula"
              max="9"
            />
            <span class="input-group-append">
              <button
                type="button"
                (click)="buscarColaborador(this.formProgramacaoFerias.get('matricula').value)"
                class="input-group-text bg-blue border-blue"
              >
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label class="font-weight-semibold">Nome do Funcionário</label>
          <input
            class="form-control"
            type="text"
            [disabled]="true"
            formControlName="nomeFuncionario"
            placeholder="Nome do Funcionário"
            maxlength="80"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('nomeFuncionario').touched) &&
              formProgramacaoFerias.get('nomeFuncionario').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>
        <div class="col-md-3 form-group">
          <label class="font-weight-semibold">Tp.Proc</label>
          <input
            class="form-control"
            type="text"
            [disabled]="true"
            formControlName="tipoProcessamento"
            placeholder="Processamento"
            maxlength="6"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('tipoProcessamento').touched) &&
              formProgramacaoFerias.get('tipoProcessamento').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>

        <div class="form-group" [ngClass]="exibirDataAfastamento ? 'col-md-2' : 'col-md-3'">
          <label class="font-weight-semibold">Codigo Afastamento</label>
          <input
            class="form-control"
            type="text"
            [disabled]="true"
            formControlName="codigoAfastamento"
            placeholder="Codigo"
            maxlength="6"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('codigoAfastamento').touched) &&
              formProgramacaoFerias.get('codigoAfastamento').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>

        <div class="form-group" [ngClass]="exibirDataAfastamento ? 'col-md-2' : 'col-md-3'">
          <label class="font-weight-semibold">Descrição Afastamento</label>
          <input
            class="form-control"
            type="text"
            [disabled]="true"
            formControlName="descricaoAfastamento"
            placeholder="Descricao"
            maxlength="6"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('descricaoAfastamento').touched) &&
              formProgramacaoFerias.get('descricaoAfastamento').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>

        <div class="col-md-2 form-group" *ngIf="exibirDataAfastamento">
          <label class="font-weight-semibold">Data Afastamento</label>
          <input
            class="form-control"
            type="date"
            [disabled]="true"
            formControlName="dataAfastamento"
            placeholder="Data"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('dataAfastamento').touched) &&
              formProgramacaoFerias.get('dataAfastamento').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>
        <div class="col-md-3 form-group">
          <label class="font-weight-semibold">Faltas</label>
          <input
            class="form-control"
            type="number"
            [disabled]="true"
            formControlName="diasFaltas"
            placeholder="Qtd. Faltas"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('diasFaltas').touched) &&
              formProgramacaoFerias.get('diasFaltas').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>

        <div class="col-md-3 form-group">
          <label class="font-weight-semibold">Dias Descontados</label>
          <input
            class="form-control"
            type="number"
            [disabled]="true"
            formControlName="diasDesc"
            placeholder="Dias Descontados"
            [ngClass]="
              (temErro || formProgramacaoFerias.get('diasDesc').touched) &&
              formProgramacaoFerias.get('diasDesc').status === 'INVALID'
                ? 'is-invalid'
                : ''
            "
          />
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="
      formProgramacaoFerias.get('matricula').value !== '' &&
      formProgramacaoFerias.get('nomeFuncionario').value !== ''
    "
    class="card shadow"
  >
    <div class="table-responsive card-body">
      <table
        class="table table-striped border-blue text-left w-100"
        *ngIf="programacoesFerias.length > 0"
      >
        <thead class="bg-teal-400">
          <tr>
            <th>Aq. Inicial</th>
            <th>Aq. Final</th>
            <th>Tipo</th>
            <th>Situação</th>
            <th>Partes</th>
            <th>Dias Pagos</th>
            <th>Dias Gozados</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let prog of programacoesFerias; let i = index">
            <td>{{ formatarData(prog.PeriodoAquisitivo.DataInicio.ToDate) }}</td>
            <td>{{ formatarData(prog.PeriodoAquisitivo.DataFim.ToDate) }}</td>
            <td>{{ prog.TipoProcessamento }}</td>
            <td>{{ prog.Situacao.Codigo }} - {{ prog.Situacao.Descricao }}</td>
            <td class="text-center">{{ prog.QuantidadeAgrupada || 1 }}</td>
            <td class="text-center">{{ prog.DiasSeremPagos }}</td>
            <td class="text-center">{{ prog.DiasGozo }}</td>
            <td class="d-flex align-items-center justify-content-center">
              <button
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Editar"
                *ngIf="exibirCampos"
                type="button"
                class="btn btn-outline-primary mr-1"
                (click)="selecionarProgramacao(prog)"
              >
                <i class="fa fa-pencil"></i>
              </button>
              <button
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Observações"
                type="button"
                [class.btn-outline-primary]="prog.Obs === 'N'"
                [class.btn-primary]="prog.Obs === 'S'"
                class="btn mr-1"
                data-toggle="modal"
                data-target="#observacoesPromocoesModal"
                (click)="modalObservacoes.abrirModal(prog)"
              >
                <i class="fa-book fa-lg fa-solid"></i>
              </button>
              <button
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Anexo"
                type="button"
                [ngClass]="{
                  'btn-outline-primary': prog.Documento === 'N',
                  'btn-primary': prog.Documento === 'S'
                }"
                class="btn mr-1"
                data-toggle="modal"
                data-target="#anexoPromocoesModal"
                (click)="modalAnexo.abrirModal(prog)"
              >
                <i class="fa fa-file"></i>
              </button>
              <button
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Deletar"
                *ngIf="exibirCampos"
                type="button"
                class="btn btn-outline-danger mr-1"
                (click)="deletarProgramacaoFerias(prog)"
              >
                <i class="fa fa-trash"></i>
              </button>
              <button
                type="button"
                data-toggle="modal"
                data-target="#editar-saldo-ferias"
                class="btn btn-block"
                [ngClass]="{
                  'btn-warning': prog.DiasSaldo > 0,
                  'btn-secondary': prog.DiasSaldo <= 0
                }"
                [disabled]="prog.DiasSaldo <= 0"
                (click)="abrirModal(prog)"
              >
                <span>{{ prog.DiasSaldo }} Dias</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="programacoesFerias.length === 0" class="p-3">
        Nenhuma programação de férias cadastrada.
      </div>
    </div>
  </div>

  <div
    *ngIf="
      formProgramacaoFerias.get('matricula').value !== '' &&
      formProgramacaoFerias.get('nomeFuncionario').value !== '' &&
      exibirCampos
    "
  >
    <div class="card-header">
      <h2 class="card-title">Formulário da Programação de Férias</h2>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card shadow-sm">
          <div class="card-header">
            <h3 class="card-title">Período aquisitivo</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-semibold">Período Inicial</label>
                <input type="date" class="form-control" formControlName="dataInicioPeriodo" />
              </div>

              <div class="col-md-6">
                <label class="font-weight-semibold">Período Final</label>
                <input type="date" class="form-control" formControlName="dataFimPeriodo" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card shadow-sm">
          <div class="card-header">
            <h3 class="card-title">Tipo Férias</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <label class="font-weight-semibold">Tipo Férias</label>
                <select
                  class="form-control"
                  formControlName="tipoFerias"
                  [ngClass]="{
                    'is-invalid':
                      formProgramacaoFerias.get('tipoFerias').invalid &&
                      formProgramacaoFerias.get('tipoFerias').touched
                  }"
                >
                  <option value="">Selecione...</option>
                  <option *ngFor="let item of listaTipoFerias" [value]="item.Codigo">
                    {{ item.Codigo }} - {{ item.Descricao }}
                  </option>
                </select>

                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('tipoFerias').invalid &&
                    formProgramacaoFerias.get('tipoFerias').touched
                  "
                >
                  Campo obrigatório
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card shadow-sm">
          <div class="card-header">
            <h3 class="card-title">Diário Oficial</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-5">
                <label for="doe">Número</label>
                <input
                  maxlength="50"
                  type="text"
                  class="form-control text-uppercase"
                  id="doe"
                  mask="A*"
                  formControlName="numeroDoe"
                  placeholder="0000"
                  [ngClass]="
                    formProgramacaoFerias.get('numeroDoe').invalid &&
                    formProgramacaoFerias.get('numeroDoe').touched
                      ? 'is-invalid'
                      : null
                  "
                />
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('numeroDoe').invalid &&
                    formProgramacaoFerias.get('numeroDoe').touched
                  "
                >
                  Campo obrigatório
                </p>
              </div>

              <div class="col-md-2">
                <label for="anoDoe">Ano</label>
                <input
                  type="text"
                  class="form-control"
                  id="anoDoe"
                  readonly
                  formControlName="anoDoe"
                  placeholder="0000"
                />
              </div>

              <div class="col-md-5">
                <label for="dtdoe">Data</label>
                <input
                  type="date"
                  class="form-control"
                  id="dtdoe"
                  max="9999-12-31"
                  formControlName="dtDoe"
                  (change)="aoAlterarData($event, 'anoDoe')"
                  [ngClass]="
                    formProgramacaoFerias.get('dtDoe').invalid &&
                    formProgramacaoFerias.get('dtDoe').touched
                      ? 'is-invalid'
                      : null
                  "
                />
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('dtDoe').hasError('required') &&
                    formProgramacaoFerias.get('dtDoe').touched
                  "
                >
                  Campo obrigatório
                </p>
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('dtDoe').hasError('dataMaiorQueAtual') &&
                    formProgramacaoFerias.get('dtDoe').touched
                  "
                >
                  A data do Diário oficial
                  {{ formProgramacaoFerias.get('dtDoe').value | date : 'dd/MM/yyyy' }} não pode ser
                  maior que a data atual.
                </p>
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('dtDoe').hasError('maxlength') &&
                    formProgramacaoFerias.get('dtDoe').touched
                  "
                >
                  Data inválida
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card shadow-sm">
          <div class="card-header">
            <h3 class="card-title">Ato</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label class="font-weight-semibold" for="idClassificacaoAto"
                  >Classificação Ato</label
                >
                <select
                  class="form-control"
                  id="idClassificacaoAto"
                  formControlName="idClassificacaoAto"
                  [ngClass]="
                    formProgramacaoFerias.get('idClassificacaoAto').invalid &&
                    formProgramacaoFerias.get('idClassificacaoAto').touched
                      ? 'is-invalid'
                      : null
                  "
                >
                  <option value="">Selecione</option>
                  <option *ngFor="let item of listaClassificacao" [value]="item.Cod">
                    {{ item.Cod }} - {{ item.Nome }}
                  </option>
                </select>
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('idClassificacaoAto').invalid &&
                    formProgramacaoFerias.get('idClassificacaoAto').touched
                  "
                >
                  Campo obrigatório
                </p>
              </div>

              <div class="col-md-3">
                <label class="font-weight-semibold" for="ato">Número</label>
                <input
                  maxlength="50"
                  type="text"
                  class="form-control text-uppercase"
                  id="ato"
                  mask="A*"
                  formControlName="numeroAto"
                  placeholder="0000"
                  [ngClass]="
                    formProgramacaoFerias.get('numeroAto').invalid &&
                    formProgramacaoFerias.get('numeroAto').touched
                      ? 'is-invalid'
                      : null
                  "
                />
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('numeroAto').invalid &&
                    formProgramacaoFerias.get('numeroAto').touched
                  "
                >
                  Campo obrigatório
                </p>
              </div>

              <div class="col-md-2">
                <label class="font-weight-semibold">Ano</label>
                <input
                  type="text"
                  class="form-control"
                  mask="0000"
                  formControlName="anoAto"
                  readonly
                  placeholder="0000"
                />
              </div>

              <div class="col-md-4">
                <label class="font-weight-semibold">Data</label>
                <input
                  type="date"
                  class="form-control"
                  max="9999-12-31"
                  formControlName="dtAto"
                  (change)="aoAlterarData($event, 'anoAto')"
                  [ngClass]="
                    formProgramacaoFerias.get('dtAto').invalid &&
                    formProgramacaoFerias.get('dtAto').touched
                      ? 'is-invalid'
                      : null
                  "
                />
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('dtAto').hasError('required') &&
                    formProgramacaoFerias.get('dtAto').touched
                  "
                >
                  Campo obrigatório
                </p>
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('dtAto').hasError('dataMaiorQueAtual') &&
                    formProgramacaoFerias.get('dtAto').touched
                  "
                >
                  A data do Ato
                  {{ formProgramacaoFerias.get('dtAto').value | date : 'dd/MM/yyyy' }} não pode ser
                  maior que a data atual.
                </p>
                <p
                  class="text-danger mt-1"
                  *ngIf="
                    formProgramacaoFerias.get('dtAto').hasError('minlength') &&
                    formProgramacaoFerias.get('dtAto').touched
                  "
                >
                  Data inválida
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      formProgramacaoFerias.get('matricula').value !== '' &&
      formProgramacaoFerias.get('nomeFuncionario').value !== '' &&
      exibirCampos
    "
    class="card"
  >
    <mat-tab-group #tabGroup>
      <mat-tab label="Parte I">
        <div class="card-header">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h3 class="card-title">Programar Férias</h3>
            </div>
          </div>
        </div>

        <div class="card-header">
          <div class="row">
            <div class="col-sm-6 form-group">
              <label class="font-weight-semibold">Situação</label>
              <select
                class="form-control"
                formControlName="situacao1"
                [ngClass]="
                  formProgramacaoFerias.get('situacao1').invalid &&
                  formProgramacaoFerias.get('situacao1').touched
                    ? 'is-invalid'
                    : null
                "
              >
                <option value="">Selecione...</option>
                <option *ngFor="let item of listaSituacao" [value]="item.Codigo">
                  {{ item.Codigo }} - {{ item.Descricao }}
                </option>
              </select>
              <p
                class="text-danger mt-1"
                *ngIf="
                  formProgramacaoFerias.get('situacao1').invalid &&
                  formProgramacaoFerias.get('situacao1').touched
                "
              >
                Campo obrigatório
              </p>
            </div>

            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Inicial</label>
              <input
                class="form-control"
                type="date"
                max="9999-12-31"
                formControlName="dtInicial1"
                (input)="calcularDataFinal(1)"
                (blur)="verificarDataInicio('dtInicial1')"
                [ngClass]="
                  formProgramacaoFerias.get('dtInicial1').invalid &&
                  formProgramacaoFerias.get('dtInicial1').touched
                    ? 'is-invalid'
                    : null
                "
              />
              <p
                class="text-danger mt-1"
                *ngIf="
                  formProgramacaoFerias.get('dtInicial1').invalid &&
                  formProgramacaoFerias.get('dtInicial1').touched
                "
              >
                Campo obrigatório
              </p>
            </div>

            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Final</label>
              <input
                [disabled]="true"
                type="date"
                class="form-control"
                formControlName="dtFinal1"
                (change)="calcularDiaRetorno(1)"
                [ngClass]="
                  formProgramacaoFerias.get('dtFinal1').invalid &&
                  formProgramacaoFerias.get('dtFinal1').touched
                    ? 'is-invalid'
                    : null
                "
              />
            </div>
            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Retorno</label>
              <input
                [disabled]="true"
                type="date"
                class="form-control"
                formControlName="dtRetorno1"
                [ngClass]="
                  formProgramacaoFerias.get('dtRetorno1').invalid &&
                  formProgramacaoFerias.get('dtRetorno1').touched
                    ? 'is-invalid'
                    : null
                "
              />
            </div>

            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Competência</label>
              <input
                type="text"
                class="form-control"
                formControlName="competencia1"
                maxlength="7"
                mask="00/0000"
                name="competencia"
                placeholder="mm/aaaa"
                [ngClass]="
                  formProgramacaoFerias.get('competencia1').invalid &&
                  formProgramacaoFerias.get('competencia1').touched
                    ? 'is-invalid'
                    : null
                "
              />
              <p
                class="text-danger mt-1"
                *ngIf="
                  formProgramacaoFerias.get('competencia1').invalid &&
                  formProgramacaoFerias.get('competencia1').touched
                "
              >
                Campo obrigatório
              </p>
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Limite Total de Dias</label>
              <input
                class="form-control"
                type="number"
                readonly
                formControlName="limiteDias1"
                placeholder="000"
              />
            </div>

            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Dias Pagamento</label>
              <input
                class="form-control"
                type="number"
                formControlName="diasSeremPagos1"
                placeholder="Dias"
                [ngClass]="
                  formProgramacaoFerias.get('diasSeremPagos1').invalid &&
                  formProgramacaoFerias.get('diasSeremPagos1').touched
                    ? 'is-invalid'
                    : null
                "
              />
              <p
                class="text-danger mt-1"
                *ngIf="
                  formProgramacaoFerias.get('diasSeremPagos1').invalid &&
                  formProgramacaoFerias.get('diasSeremPagos1').touched
                "
              >
                Campo obrigatório
              </p>
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Dias a Gozar</label>
              <input
                class="form-control"
                type="number"
                formControlName="diasGozo1"
                (blur)="calcularDataFinal(1)"
                placeholder="Dias"
                [ngClass]="
                  formProgramacaoFerias.get('diasGozo1').invalid &&
                  formProgramacaoFerias.get('diasGozo1').touched
                    ? 'is-invalid'
                    : null
                "
              />
              <p
                class="text-danger mt-1"
                *ngIf="
                  formProgramacaoFerias.get('diasGozo1').invalid &&
                  formProgramacaoFerias.get('diasGozo1').touched
                "
              >
                Campo obrigatório
              </p>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Parte II">
        <div class="card-header">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h3 class="card-title">Programar Férias</h3>
            </div>
          </div>
        </div>
        <div class="card-header">
          <div class="row">
            <div class="col-sm-6 form-group">
              <label class="font-weight-semibold">Situação</label>
              <select class="form-control" formControlName="situacao2">
                <option value="">Selecione...</option>
                <option *ngFor="let item of listaSituacao" [value]="item.Codigo">
                  {{ item.Codigo }} - {{ item.Descricao }}
                </option>
              </select>
            </div>

            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Inicial</label>
              <input
                class="form-control"
                type="date"
                max="9999-12-31"
                formControlName="dtInicial2"
                (input)="calcularDataFinal(2)"
                (blur)="verificarDataInicio('dtInicial2')"
              />
            </div>
            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Final</label>
              <input
                [disabled]="true"
                type="date"
                class="form-control"
                formControlName="dtFinal2"
                (change)="calcularDiaRetorno(2)"
              />
            </div>
            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Retorno</label>
              <input
                [disabled]="true"
                type="date"
                class="form-control"
                formControlName="dtRetorno2"
              />
            </div>

            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Competência</label>
              <input
                type="text"
                class="form-control"
                formControlName="competencia2"
                maxlength="7"
                mask="00/0000"
                name="competencia"
                placeholder="mm/aaaa"
              />
            </div>

            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Limite Total de Dias</label>
              <input
                class="form-control"
                type="number"
                readonly
                formControlName="limiteDias1"
                placeholder="000"
              />
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Dias de Pagamento</label>
              <input
                class="form-control"
                type="number"
                formControlName="diasSeremPagos2"
                placeholder="Dias"
              />
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Dias a Gozar</label>
              <input
                class="form-control"
                type="number"
                formControlName="diasGozo2"
                (blur)="calcularDataFinal(2)"
                placeholder="Dias"
              />
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Parte III">
        <div class="card-header">
          <div class="col-12">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h3 class="card-title">Programar Férias</h3>
            </div>
          </div>
        </div>
        <div class="card-header">
          <div class="row">
            <div class="col-sm-6 form-group">
              <label class="font-weight-semibold">Situação</label>
              <select class="form-control" formControlName="situacao3">
                <option value="">Selecione...</option>
                <option *ngFor="let item of listaSituacao" [value]="item.Codigo">
                  {{ item.Codigo }} - {{ item.Descricao }}
                </option>
              </select>
            </div>

            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Inicial</label>
              <input
                class="form-control"
                type="date"
                max="9999-12-31"
                formControlName="dtInicial3"
                (input)="calcularDataFinal(3)"
                (blur)="verificarDataInicio('dtInicial3')"
              />
            </div>
            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Final</label>
              <input
                [disabled]="true"
                type="date"
                class="form-control"
                formControlName="dtFinal3"
                (change)="calcularDiaRetorno(3)"
              />
            </div>
            <div class="col-sm-2 form-group">
              <label class="font-weight-semibold">Data Retorno</label>
              <input
                [disabled]="true"
                type="date"
                class="form-control"
                formControlName="dtRetorno3"
              />
            </div>

            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Competência</label>
              <input
                type="text"
                class="form-control"
                formControlName="competencia3"
                maxlength="7"
                mask="00/0000"
                name="competencia"
                placeholder="mm/aaaa"
              />
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Limite Total de Dias</label>
              <input
                class="form-control"
                type="number"
                readonly
                formControlName="limiteDias1"
                placeholder="000"
              />
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Dias de Pagamento</label>
              <input
                class="form-control"
                type="number"
                formControlName="diasSeremPagos3"
                placeholder="Dias"
              />
            </div>
            <div class="col-sm-3 form-group">
              <label class="font-weight-semibold">Dias a Gozar</label>
              <input
                class="form-control"
                type="number"
                formControlName="diasGozo3"
                (blur)="calcularDataFinal(3)"
                placeholder="Dias"
              />
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="card-header">
      <div class="text-right">
        <button
          type="button"
          class="btn btn-primary"
          (click)="modoEdicao ? salvarEdicaoProgramacaoFerias() : salvarProgramacaoFerias()"
        >
          {{ modoEdicao ? 'Atualizar' : 'Cadastrar' }}
        </button>

        <button
          *ngIf="modoEdicao"
          type="button"
          class="btn btn-secondary ml-2"
          (click)="cancelarEdicao()"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</form>

<div class="modal fade" id="editar-saldo-ferias" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Saldo de <strong>{{ programacaoSelecionada?.DiasSaldo || 0 }}</strong> dias Férias
        </h5>
      </div>
      <div class="modal-body">
        <form name="form-saldo">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 form-group">
                  <label>Período Aquisitivo</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      [value]="
                        formatarData(programacaoSelecionada?.PeriodoAquisitivo?.DataInicio?.ToDate)
                      "
                      disabled
                    />
                    <input
                      type="text"
                      class="form-control"
                      [value]="
                        formatarData(programacaoSelecionada?.PeriodoAquisitivo?.DataFim?.ToDate)
                      "
                      disabled
                    />
                  </div>
                </div>
                <div class="col-sm-4 form-group">
                  <label>Dias gozo</label>
                  <input
                    type="number"
                    class="form-control"
                    [class.is-invalid]="
                      !diasGozoValido && (formProgramacaoFerias.touched || diasGozoSaldo !== null)
                    "
                    placeholder="0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    [(ngModel)]="diasGozoSaldo"
                    [ngModelOptions]="{ standalone: true }"
                    [max]="programacaoSelecionada?.DiasSaldo"
                    min="1"
                    required
                    (input)="corrigirDiasGozo($event); diasGozoValido = true"
                  />
                  <div
                    *ngIf="
                      !diasGozoValido && (formProgramacaoFerias.touched || diasGozoSaldo !== null)
                    "
                    class="invalid-feedback d-block"
                  >
                    Campo obrigatório
                  </div>
                  <small class="form-text text-muted" *ngIf="programacaoSelecionada?.DiasSaldo">
                    Máximo permitido: {{ programacaoSelecionada?.DiasSaldo }} dias
                  </small>
                </div>

                <div class="col-sm-4 form-group">
                  <label>Data início gozo</label>
                  <input
                    type="date"
                    class="form-control"
                    [class.is-invalid]="!dataInicioGozoValido && formProgramacaoFerias.touched"
                    max="9999-12-31"
                    [(ngModel)]="dataInicioGozo"
                    [ngModelOptions]="{ standalone: true }"
                    required
                    (input)="dataInicioGozoValido = true"
                  />
                  <div
                    *ngIf="!dataInicioGozoValido && formProgramacaoFerias.touched"
                    class="invalid-feedback d-block"
                  >
                    Campo obrigatório
                  </div>
                </div>
                <div class="col-sm-4 form-group">
                  <label>Data final gozo</label>
                  <input
                    type="date"
                    class="form-control"
                    [value]="calcularDataFinalGozo()"
                    disabled
                  />
                </div>

                <div class="col-sm-12 mb-3">
                  <label class="font-weight-semibold">Diário Oficial</label>

                  <div class="row">
                    <div class="col-md-6">
                      <label for="doe">Número</label>
                      <input
                        maxlength="50"
                        type="text"
                        class="form-control text-uppercase"
                        id="doe"
                        mask="A*"
                        [(ngModel)]="numeroDoeSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="0000"
                        [class.is-invalid]="
                          !numeroDoeSaldoValido &&
                          (formProgramacaoFerias.touched || numeroDoeSaldo !== null)
                        "
                        required
                        (input)="numeroDoeSaldoValido = true"
                      />
                      <div
                        *ngIf="
                          !numeroDoeSaldoValido &&
                          (formProgramacaoFerias.touched || numeroDoeSaldo !== null)
                        "
                        class="invalid-feedback d-block"
                      >
                        Campo obrigatório
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="anoDoeSaldo">Ano</label>
                      <input
                        type="text"
                        class="form-control"
                        id="anoDoeSaldo"
                        readonly
                        [(ngModel)]="anoDoeSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="0000"
                      />
                    </div>

                    <div class="col-md-4">
                      <label for="dtdoeSaldo">Data</label>
                      <input
                        type="date"
                        class="form-control"
                        id="dtdoeSaldo"
                        max="9999-12-31"
                        [(ngModel)]="dtDoeSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        [class.is-invalid]="
                          (!dtDoeSaldoValido &&
                            (formProgramacaoFerias.touched || dtDoeSaldo !== null)) ||
                          (dtDoeSaldoValido && dtDoeSaldo && isDataMaiorQueAtual(dtDoeSaldo))
                        "
                        (input)="dtDoeSaldoValido = true; aoAlterarDataSaldo($event, 'anoDoeSaldo')"
                        required
                      />
                      <div
                        *ngIf="
                          !dtDoeSaldoValido &&
                          (formProgramacaoFerias.touched || dtDoeSaldo !== null)
                        "
                        class="invalid-feedback d-block"
                      >
                        Campo obrigatório
                      </div>
                      <div
                        *ngIf="dtDoeSaldoValido && dtDoeSaldo && isDataMaiorQueAtual(dtDoeSaldo)"
                        class="invalid-feedback d-block"
                      >
                        A data do Diário Oficial {{ dtDoeSaldo | date : 'dd/MM/yyyy' }} não pode ser
                        maior que a data atual.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12">
                  <label class="font-weight-semibold">Ato</label>

                  <div class="row">
                    <div class="col-md-3">
                      <label for="idClassificacaoAtoSaldo">Classificação Ato</label>
                      <select
                        class="form-control"
                        id="idClassificacaoAtoSaldo"
                        [(ngModel)]="idClassificacaoAtoSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        [class.is-invalid]="
                          !idClassificacaoAtoSaldoValido &&
                          (formProgramacaoFerias.touched || idClassificacaoAtoSaldo !== null)
                        "
                        required
                        (change)="idClassificacaoAtoSaldoValido = true"
                      >
                        <option value="">Selecione</option>
                        <option *ngFor="let item of listaClassificacao" [value]="item.Cod">
                          {{ item.Cod }} - {{ item.Nome }}
                        </option>
                      </select>
                      <div
                        *ngIf="
                          !idClassificacaoAtoSaldoValido &&
                          (formProgramacaoFerias.touched || idClassificacaoAtoSaldo !== null)
                        "
                        class="invalid-feedback d-block"
                      >
                        Campo obrigatório
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="ato">Número</label>
                      <input
                        maxlength="50"
                        type="text"
                        class="form-control text-uppercase"
                        id="ato"
                        mask="A*"
                        [(ngModel)]="numeroAtoSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="0000"
                        [class.is-invalid]="
                          !numeroAtoSaldoValido &&
                          (formProgramacaoFerias.touched || numeroAtoSaldo !== null)
                        "
                        required
                        (input)="numeroAtoSaldoValido = true"
                      />
                      <div
                        *ngIf="
                          !numeroAtoSaldoValido &&
                          (formProgramacaoFerias.touched || numeroAtoSaldo !== null)
                        "
                        class="invalid-feedback d-block"
                      >
                        Campo obrigatório
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label>Ano</label>
                      <input
                        type="text"
                        class="form-control"
                        mask="0000"
                        [(ngModel)]="anoAtoSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        readonly
                        placeholder="0000"
                      />
                    </div>

                    <div class="col-md-4">
                      <label>Data</label>
                      <input
                        type="date"
                        class="form-control"
                        max="9999-12-31"
                        [(ngModel)]="dtAtoSaldo"
                        [ngModelOptions]="{ standalone: true }"
                        [class.is-invalid]="
                          !dtAtoSaldoValido &&
                          (formProgramacaoFerias.touched || dtAtoSaldo !== null)
                        "
                        required
                        (input)="dtAtoSaldoValido = true; aoAlterarDataSaldo($event, 'anoAtoSaldo')"
                      />
                      <div
                        *ngIf="
                          !dtAtoSaldoValido &&
                          (formProgramacaoFerias.touched || dtAtoSaldo !== null)
                        "
                        class="invalid-feedback d-block"
                      >
                        Campo obrigatório
                      </div>
                      <div
                        *ngIf="dtAtoSaldoValido && dtAtoSaldo && isDataMaiorQueAtual(dtAtoSaldo)"
                        class="invalid-feedback d-block"
                      >
                        A data do Ato {{ dtAtoSaldo | date : 'dd/MM/yyyy' }} não pode ser maior que
                        a data atual.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-right">
              <button
                type="button"
                class="btn btn-outline-secondary mr-2"
                (click)="limparCamposGozoSaldo()"
              >
                <span>Limpar</span>
                <i class="fa fa-eraser"></i>
              </button>
              <button type="button" class="btn btn-primary mr-2" (click)="salvarSaldoFerias()">
                <span>Salvar </span>
                <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </form>

        <h5 class="text-muted">Gozos já registrados</h5>
        <div class="card shadow-sm">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped" *ngIf="historicoGozos?.length > 0; else semDados">
                <thead>
                  <tr>
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Dias</th>
                    <th class="text-right">Remover</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let gozo of historicoGozos">
                    <td class="text-center">{{ gozo.DataInicio.ToDate }}</td>
                    <td class="text-center">{{ gozo.DataFim.ToDate }}</td>
                    <td class="text-center">{{ gozo.Dias }}</td>
                    <td class="text-right">
                      <button
                        type="button"
                        class="btn btn-sm"
                        [ngClass]="{
                          'btn-outline-danger': !isGozoPassado(gozo.DataInicio),
                          'btn-secondary': isGozoPassado(gozo.DataInicio)
                        }"
                        [disabled]="isGozoPassado(gozo.DataInicio)"
                        (click)="removerGozoFerias(gozo)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <ng-template #semDados>
                <div class="p-3 text-center text-muted">Nenhum dado cadastrado.</div>
              </ng-template>
            </div>

            <div class="alert alert-warning text-center" *ngIf="historicoGozos.length > 0">
              <strong>Atenção:</strong>
              <span>Registros já passados não podem mais ser excluídos!</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
          <span>Fechar </span>
          <i class="fa fa-close"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="observacoesPromocoesModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-observacoes-ficha-funcional
        (gatilhoAtivado)="listarProgramacaoFerias()"
        [colaborador]="colaborador"
        [tipo]="tipoPagina"
      >
      </app-observacoes-ficha-funcional>
    </div>
  </div>
</div>
<div class="modal fade" id="anexoPromocoesModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-anexo
        *ngIf="colaborador?.Matricula"
        [pagina]="tipoPagina"
        (gatilhoAtivado)="listarProgramacaoFerias()"
        [matricula]="colaborador?.Matricula"
        [enviarSeparadamente]="true"
        [modal]="true"
      ></app-anexo>
    </div>
  </div>
</div>
